import { useEffect, useState } from 'react';

/**
 * Returns true only after `active` has stayed true continuously for `delayMs`. Used to gate loading
 * spinners so a sub-`delayMs` load (e.g. a fast cached navigation) never flashes a spinner in and
 * straight back out — the flicker. If `active` clears before the delay elapses, the flag never flips
 * true. Default 200ms: below the ~250ms where a spinner reads as "loading" rather than a glitch.
 */
export function useDelayedFlag(active: boolean, delayMs = 200): boolean {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const timer = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return shown;
}
